import { useMailingRepository } from '@Hooks/useRepository';
import type { ApiSendEmailRequest } from '@Model';
import { EmailsRepository } from '@Repositories/Mailing';
import { useMutation } from '@tanstack/react-query';
import { Base64 } from 'js-base64';

export const useSendEmail = () => {
    const emails = useMailingRepository(EmailsRepository);

    const mutation = useMutation({
        mutationFn: (sendEmailRequest: ApiSendEmailRequest) => {
            const encodedEmailRequest: ApiSendEmailRequest = {
                ...sendEmailRequest,
                body: Base64.encode(sendEmailRequest.body),
            };
            return emails.sendEmail(encodedEmailRequest);
        },
    });

    return {
        sendEmail: mutation.mutateAsync,
        isPending: mutation.isPending,
    };
};
